import dataList from './data-list';
import formArea from './form-area';
import tabBar from './tab-bar';
import selectEntity from './select-entity';
import coordinatePicker from './coordinate-picker';
import timePeriod from './time-period';
import liveConfig from './live-config';
import formUpload from './form-upload';
import fileUpload from './file-upload';
import longText from './long-text';
import moduleSetting from './module-setting';
import tinyEditor from  './tiny-editor';

const install = function (Vue) {
    Vue.component("dataList", dataList);
    Vue.component("selectEntity", selectEntity);
    Vue.component("coordinatePicker", coordinatePicker);
    Vue.component("timePeriod", timePeriod);
    Vue.component("liveConfig", liveConfig);
    Vue.component("tinyEditor", tinyEditor);
    Vue.component("formUpload", formUpload);
    Vue.component("fileUpload", fileUpload);
    Vue.component("formArea", formArea);
    Vue.component("tabBar", tabBar);
    Vue.component("longText", longText);
    Vue.component("moduleSetting", moduleSetting);
    Vue.component("Vnodes", {
        functional: true,
        render: (h, ctx) => ctx.props.vnodes
    });
}

export default install;
